import React from 'react';
import './OldFileErrorPage.css'; // Import the CSS file

const OldFileErrorPage = () => (
  <div className="es-wrapper-color">
    <table className="es-wrapper" cellspacing="0" cellpadding="0">
      <tr>
        <td valign="top" align="center" bgcolor="#ffffff">
          {/* HEADER IMAGE */}
          <img src="https://artiness-static-files-public.s3.eu-central-1.amazonaws.com/header-planner.jpeg" alt="ARTICOR planner" width="330"/>
          
          {/* BODY */}
          <div align="left" className="es-content-body">
            <p>Dear user,</p>
            <p>The link you tried to access is out of date.</p>
            <p>Please access <strong><a href="https://www.artinessreality.com/medical/eifu" target="_blank">www.artinessreality.com/medical/eifu</a></strong> to obtain the latest revision of the Instructions for Use.</p>
            <p><strong>Thank you for choosing ARTICOR<sup>®</sup> planner!</strong></p>
          </div>

          {/* FOOTER IMAGE */}
          <img src="https://artiness-static-files-public.s3.eu-central-1.amazonaws.com/footer-planner.jpg" alt="ARTINESS THE NEW WAY TO LOOK INSIDE" width="100%"/>

          {/* COPYRIGHT */}
          <div className="es-footer-body">
            <p><b>© 2026 Artiness.</b> All rights reserved.
            <br/>Artiness is a registered trademark of Artiness S.r.l.</p>
          </div>
        </td>
      </tr>
    </table>
  </div>
);

export default OldFileErrorPage;